"use client";

import { faLink } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import copy from "copy-to-clipboard";
import { Button } from "~/components/ui/button";
import { useToast } from "~/components/ui/use-toast";

type Props = {
  title: string;
  toast: string;
};

export default function CopyLinkButton({ toast: toastMessage, title }: Props) {
  const { toast } = useToast();
  const handleCopyLink = async () => {
    copy(window.location.href, {
      format: "text/plain",
    });
    toast({
      title: toastMessage,
    });
  };

  return (
    <Button
      type="button"
      className="w-full text-link"
      variant="outline"
      onClick={handleCopyLink}
    >
      <FontAwesomeIcon icon={faLink} />
      <span>{title}</span>
    </Button>
  );
}
